import { render, staticRenderFns } from "./Links.vue?vue&type=template&id=96c8e404&"
import script from "./Links.vue?vue&type=script&lang=ts&"
export * from "./Links.vue?vue&type=script&lang=ts&"
import style0 from "./Links.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports